export const en = {
  "2d": "2D",
  "3d": "3D",
  confirm: "Confirm",
  confirmshape: "Update Shape",
  notFound: "Not Found",
  next: "Next",
  back: "Back",
  export: " Export",
  gapWidth: "Gap Width",
  wallWidth: "Wall Width",
  balconyWidth: "Balcony Width",
  clearAllTip: "Clear All",
  drawBalconyTip: "Draw Balcony",
  drawWallTip: "Draw Wall",
  drawGapTip: "Draw Gap",
  search: "Search",
  //WelcomeMenu.tsx
  welcomeMenuWelcome: "Hello! Welcome to the Planner!",
  drawRoomShape: "Draw Own Room",
  chooseRoomShapeFromTemplates: "Choose From Templates",
  chooseRoomShape: "Choose Room Shape",
  //MainPane.tsx
  roomFeatures: "Size",
  drawWall: "Dimensions",
  showReport: "Offer",
  addToRoom: "Products",
  configure: "Configure",
  //RoomShaping.tsx
  changeRoomShape: "Change Room Shape",
  newRoom: "Clear",
  roomShapeOnlyFloor: "Floor",
  roomShapeFloorWithSingleWall: "Single Wall",
  roomShapeCorner: "Corner",
  roomDoubleBalcony: "Corner Shape",
  roomShapeRectangle: "Rectangle",
  roomShapeSquare: "Square",
  roomShapeLShape: "L Shape",
  roomShapeZShape: "Z Shape",
  roomShapeUShape: "U Shape",
  roomShapeTShape: "T Shape",
  roomShape5Sides: "5 Side",
  roomShapeBevelShape: "Bevel Shape",
  //RoomModifying.tsx
  wallResize: "Resize Walls",
  glassPriceMultiplier: "Glass Price per Meter",
  basePriceMultiplier: "Base Price per Unit",
  buyerName: "Buyer Name",
  dimensions: "Dimensions",
  resetArea: "Reset Area",
  undo: "Undo",
  topView: "Top View",
  createRender: "Create Render",
  calculating: "Calculating...",
  loading: "Loading...",
  productList: "Product List",
  proforma: {
    modelSummary: "Normod Design Summary",
    pdfGenerating: "Generating PDF...",
    pdfLibraryError: "PDF library could not be loaded",
    pdfError: "PDF could not be created. Please try again.",
    pdfError2: "An error occurred while creating the PDF. Please try again.",
    offerNo: "Offer No",
    quantity: "Quantity",
    product: "Product",
    price: "Price",
    subtotal: "Subtotal",
    dimensions: "Dimensions",
    materialType: "Material Type",
    materialColor: "Material Color",
    orderDate: "Order Date",
    discount: "Discount",
    taxIncluded: "Tax (Included) VAT-10%",
    total: "TOTAL",
    footer1: "Prices include VAT.",
    footer2: "Prices are valid for the day the form is created.",
    footer3:
      "This form is for offer purposes only and cannot be used for ordering.",
    footer4:
      "This design was prepared specifically for the person on {{date}}.",
    footer5:
      "Our products are designed for comfort. Since rich fiber and high elasticity premium sponges are used, stitches may not be straight and sharp.",
    footer6: "Colors on the screen may show tone differences.",
    footer7: "The validity period of the offer is 3 days.",
    preview3d: "3D Preview",
    setProjectName: "Set Project Name",
    pdfWillBeSavedAs: "The PDF file will be saved with this name",
    projectName: "Project Name",
    projectNamePlaceholder: "e.g. Kitchen Design",
    cancel: "Cancel",
    createPdf: "Create PDF",
    priceAsc: "Price ↑",
    priceDesc: "Price ↓",
    sort: "Sort",
    productDetails: "Product Details",
    cm: "cm",
    addToCart: "Add to Cart",
    share: "Share",
  },
  tips: {
    doneBtnText: "Got it",
    onboarding: {
      welcomeTitle: "Welcome to Room Designer!",
      welcomeDesc: "This short tour will introduce you to the design tools. You can close it anytime.",
      canvasTitle: "Your Design Area",
      canvasDesc: "You'll view and edit your room here. Draw walls in 2D mode, place products and preview in 3D mode.",
      toolbarTitle: "Toolbar",
      toolbarDesc: "Drawing tools, undo and view switching buttons are here. Let's go through them one by one.",
      viewModeTitle: "View Mode",
      viewModeDesc: "2D: Wall drawing and plan view. 3D: Realistic preview and product placement. You can switch between them.",
      undoTitle: "Undo / Redo",
      undoDesc: "You can undo or redo your actions.",
      drawWallTitle: "Draw Wall",
      drawWallDesc: "After selecting this tool, click on the design area to set wall corners. Click the starting point to close the room.",
      balconyTitle: "Add Balcony",
      balconyDesc: "Use this tool to draw a balcony. Click between points to draw, just like walls.",
      panelTitle: "Product & Material Panel",
      panelDesc: "Manage products, materials and room features from this panel. Navigate between categories using the tabs above.",
      categoriesTitle: "Categories",
      categoriesDesc: "You can find Room Features, Products, Materials and Export tabs here.",
      helpTitle: "Need Help?",
      helpDesc: "Click this button to restart this tour anytime. Happy designing!",
    },
    contextual: {
      threeDModeTitle: "You're in 3D View",
      threeDModeDesc: "Right-click and drag to rotate the camera. Use the mouse wheel to zoom in and out.",
      drawerActiveTitle: "Drawing Mode Active",
      drawerActiveDesc: "Click on the design area to set corner points. Click the starting point again or double-click to finish drawing.",
      productSelectedTitle: "Product Selected",
      productSelectedDesc: "From this menu you can rotate, delete or replace the product with another one.",
      wallSelectedTitle: "Wall Settings",
      wallSelectedDesc: "From this window you can change the wall type and adjust dimensions.",
      cornerButtonsTitle: "Wall Extension Point",
      cornerButtonsDesc: "Click these '+' buttons to add new walls to existing corners.",
      backTo2dTitle: "You're in 2D Mode",
      backTo2dDesc: "Now you can draw walls, change wall dimensions and continue working in plan view.",
    },
    progress: {
      roomCreatedTitle: "Your Room is Ready!",
      roomCreatedDesc: "Now you can add furniture and accessories from the 'Products' tab in the right panel. Drag-and-drop or click to add.",
      firstProductTitle: "First Product Added!",
      firstProductDesc: "Click a product to select it, then rotate, delete or replace it. Switch to 3D view to check how it looks.",
      threeDPreviewTitle: "3D Preview Looks Great!",
      threeDPreviewDesc: "You can change wall, floor and ceiling materials from the 'Materials' tab.",
      materialChangedTitle: "Your Design is Taking Shape!",
      materialChangedDesc: "When you're ready, you can save or share your design from the 'Export' tab.",
      wallResizedTitle: "Wall Size Updated",
      wallResizedDesc: "Switch to 3D view to check how the changes look.",
    },
  },
  side: {
    backCushion: "Back Cushion",
    armOption: "Arm Option",
    fabricDetails: "Fabric Details",
    apply: "Apply",
    materialGroupDescription:
      "Select from the found fabric types and choose your desired color from its subgroup to customize your product.",
  },
};
